import { Injectable, inject } from "@angular/core";
import { CanActivate } from "@angular/router";
import { LocaleService } from "src/app/services/locale.service";

import { sntLog } from "src/app/common/logger";

const logger = sntLog("SyncLocaleWithTenantAvailableGuard");
@Injectable()
export class SyncLocaleWithTenantAvailableGuard implements CanActivate {
  private readonly localeService = inject(LocaleService);

  async canActivate(): Promise<boolean> {
    const localeToSet = await this.localeService.getLocaleWanted();

    await this.localeService.setLocale(localeToSet);

    logger.debug(
      `[SyncLocaleWithTenantAvailableGuard] localeToSet: ${localeToSet}`
    );

    return true;
  }
}
